import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-primary text-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12">
          <div className="col-span-1">
            <img
              src="https://public.readdy.ai/ai/img_res/c48bc4d0-f766-490d-9bb5-39139618b7b6.png"
              alt="True Passage Ventures"
              className="h-10 sm:h-12 w-auto mb-4"
            />
            <p className="text-sm text-white/65 leading-relaxed">
              Connecting global buyers with verified suppliers for reliable supply chain solutions.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Company</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-white/65 hover:text-gold-accent transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-sm text-white/65 hover:text-gold-accent transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-white/65 hover:text-gold-accent transition-colors">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm text-white/65 hover:text-gold-accent transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-sm text-white/65 hover:text-gold-accent transition-colors">
                  Resources
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Products</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/products?filter=packaging" className="text-sm text-white/65 hover:text-gold-accent transition-colors cursor-pointer">
                  Packaging
                </Link>
              </li>
              <li>
                <Link to="/products?filter=industrial" className="text-sm text-white/65 hover:text-gold-accent transition-colors cursor-pointer">
                  Light Industrial
                </Link>
              </li>
              <li>
                <Link to="/products?filter=plastics" className="text-sm text-white/65 hover:text-gold-accent transition-colors cursor-pointer">
                  Plastics
                </Link>
              </li>
              <li>
                <Link to="/products?filter=oem" className="text-sm text-white/65 hover:text-gold-accent transition-colors cursor-pointer">
                  OEM Engineering
                </Link>
              </li>
              <li>
                <Link to="/products?filter=home" className="text-sm text-white/65 hover:text-gold-accent transition-colors cursor-pointer">
                  Home & Agriculture
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="text-sm text-white/65">contact@truepassage.org</li>
              <li className="text-sm text-white/65">+1 (437) 981-2110</li>
              <li className="text-sm text-white/65">Canada</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 sm:mt-12 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
          <p className="text-sm text-white/50 text-center sm:text-left">
            © {currentYear} True Passage Ventures. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-white/50 hover:text-gold-accent transition-colors"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;